import { Link, Redirect } from 'react-router-dom';
import RectButton from "../../ui/button/RectButton";
import Input from "../../ui/Input";

// import PaperAirplane from '../../assets/images/paper-airplane.svg';
import * as paperPlaneData from '../../assets/json/lottie/paper-plane.json'
import { ReactComponent as LetterIC } from '../../assets/icons/letter-ic.svg';
import { ReactComponent as FacebookIC } from '../../assets/icons/f-ic.svg';
import { ReactComponent as GoogleIC } from '../../assets/icons/g-ic.svg';

import './style.scss';
import Modal from "..";
import { Component } from 'react';
import AppContext from '../../../contexts/AppContext';
import User from '../../../model/User';
import { validate } from '../../../utils';
import ConfirmPopup from '../../Popup/ConfirmPopup';
import Lottie from 'react-lottie';

class SignIn extends Component {
    static contextType = AppContext;

    state={
        email:null,
        password: null
    }

    signIn = () => {
        let result = validate([
            {value:this.state.email},
            {value:this.state.password},
        ])
        if(result.valid) this.context.setUser(new User(1,"Ari Kaplan"));
        else this.context.setPopup(<ConfirmPopup message="Please make sure all fields are filled in correctly" />)
    }

    componentDidMount(){
        this.context.setPage({id:"signin"});
    }

    componentWillUnmount(){
        this.context.setPage({id:null});
    }

    render() {
        if (this.context.user) {
            return <Redirect to="/" />
        }

        return (
            <>
                <Modal className="signin" relative={this.props.relative}>
                    <h3>Sign In to Continue</h3>
                    <div className="container">
                        <form>
                            <Input type="email" name="email" placeHolder="Email Address" onChange={(value)=>this.setState({email:value})} />
                            <Input type="password" name="password" placeHolder="Password" onChange={(value)=>this.setState({password:value})} />
                            <RectButton icon={<LetterIC />} text="SIGN IN" onClick={this.signIn} />
                        </form>
                        <Link className="uh forgot" to="/forgot">Forgot Password?</Link>
                        <div className="social-login">
                            <div className="or"><span>OR</span></div>
                            <h3>Sign In With</h3>
                            <div className="social-bts">
                                <RectButton icon={<FacebookIC />} bgColor="#506DAA" text="FACEBOOK" onClick={this.signIn} />
                                <RectButton icon={<GoogleIC />} bgColor="#DD2727" text="GOOGLE" onClick={this.signIn} />
                            </div>
                        </div>
                        <div className="account-ask"><span>Don’t have an account?</span><Link className="uh" to="/signup">Sign Up</Link></div>
                    </div>
                    <div className="paper-airplane">
                        <Lottie options={{
                            loop: false,
                            autoplay: true,
                            animationData: paperPlaneData.default,
                        }}
                            height="100%"
                            width="100%" />
                    </div>
                    {/* <img className="paper-airplane" src={PaperAirplane} alt="Paper Airplane" /> */}
                </Modal>
            </>
        )
    }
}

export default SignIn;